// extracted by mini-css-extract-plugin
export default {"basic":"PageTop_basic__t3aKh","scoreCard":"PageTop_scoreCard__ZEOtr","scoreCardWrapper":"PageTop_scoreCardWrapper__wm3hy","pageText":"PageTop_pageText__sPBjq"};